import type { SplitTestConfig } from '../splitTestTypes';
import { RAW_LEVELS } from '../../../../levels';
import { NEW_RAW_LEVELS } from '../../../../levels/newLevels/newRawLevels';
import { GAME_ECONOMY_SETTINGS } from '../../../game/GameConstants';
import { BoosterType } from '../../../game/boosters/types';

export const hs915FirstLevelsSplitTest: SplitTestConfig = {
  distributions: 2,
  newUserTestSlug: 'FirstLevels_NU_HS915',
  returningUserTestSlug: null,
  onActive(_, distribution) {
    if (distribution === 1) return;

    GAME_ECONOMY_SETTINGS.boosters[BoosterType.Hammer].unlockLevel = 4;
    GAME_ECONOMY_SETTINGS.boosters[BoosterType.Redraw].unlockLevel = 10;
    GAME_ECONOMY_SETTINGS.boosters[BoosterType.Move].unlockLevel = 17;
    GAME_ECONOMY_SETTINGS.boosters[BoosterType.Undo].unlockLevel = 24;

    NEW_RAW_LEVELS.forEach((level, index) => {
      RAW_LEVELS[index] = level;
    });
  },
};
